import React, { useMemo } from 'react';
import { compareFunds } from './compareFunds';
import { ExpandedFundClassificationTypeHeader } from './ExpandedFundClassificationTypeHeader';
import { ExpandedFundGroupHeaderProps } from './ExpandedFundGroupHeader';

export const MaybeExpandedFundClassificationTypeHeader: React.VFC<
  ExpandedFundGroupHeaderProps
> = ({ fund, lastFund }) => {
  const { firstOfClassification, firstOfAgreement, displayClassification } =
    useMemo(() => compareFunds(fund, lastFund), [fund, lastFund]);
  return firstOfClassification || firstOfAgreement ? (
    <ExpandedFundClassificationTypeHeader singleColumn>
      {displayClassification}
    </ExpandedFundClassificationTypeHeader>
  ) : (
    <React.Fragment />
  );
};
